const isFunction = (val) => typeof val === "function";
const isObject = (val) => val !== null && typeof val === "object";
export {
  isFunction,
  isObject
};
